<template>
  <footer class="footer-vigna">
    <div class="container">
      <div class="social-icons">
        <!-- Lien Twitter -->
        <a
          href="https://fictif-link.com/twitter"
          target="_blank"
          aria-label="Twitter"
        >
          <fa :icon="['fab', 'x-twitter']" class="icon" />
        </a>
        <!-- Lien Facebook -->
        <a
          href="https://fictif-link.com/facebook"
          target="_blank"
          aria-label="Facebook"
        >
          <fa :icon="['fab', 'facebook']" class="icon" />
        </a>
        <!-- Lien Instagram -->
        <a
          href="https://fictif-link.com/instagram"
          target="_blank"
          aria-label="Instagram"
        >
          <fa :icon="['fab', 'instagram']" class="icon" />
        </a>
        <!-- Lien LinkedIn -->
        <a
          href="https://fictif-link.com/linkedin"
          target="_blank"
          aria-label="LinkedIn"
        >
          <fa :icon="['fab', 'linkedin']" class="icon" />
        </a>
      </div>
      <div class="footer-text">
        <p>
          © 2025 VMCT SPRL |
          <a href="mailto:vmct@vigna.be" class="text-link">vmct@vigna.be</a>
          |
          <router-link to="/conditions" class="text-link"
            >Conditions générales</router-link
          >
          | BCE : BE 0886.542.881
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterVigna'
}
</script>
